import React from 'react';

/** Decorative puzzle-brain motif (brain + jigsaw piece), echoes the LQ logo. */
export default function PuzzleMotif({ size = 140, className = '', opacity = 0.18 }) {
    return (
        <svg viewBox="0 0 200 200" width={size} height={size} aria-hidden="true" className={className} style={{ opacity }}>
            <defs>
                <linearGradient id="pm-grad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#7B3FA9" />
                    <stop offset="100%" stopColor="#F5A67C" />
                </linearGradient>
            </defs>
            {/* 4 puzzle pieces forming a 2x2 */}
            <path d="M30 30 H90 Q95 30 95 37 Q95 45 102 45 Q109 45 109 37 Q109 30 114 30 H170 Q170 50 170 90 Q170 95 163 95 Q155 95 155 102 Q155 109 163 109 Q170 109 170 114 V170 H114 Q109 170 109 163 Q109 155 102 155 Q95 155 95 163 Q95 170 90 170 H30 V114 Q30 109 37 109 Q45 109 45 102 Q45 95 37 95 Q30 95 30 90 Z"
                fill="url(#pm-grad)" />
            {/* Brain silhouette overlay */}
            <g opacity="0.5" fill="none" stroke="#3A1A55" strokeWidth="3" strokeLinecap="round">
                <path d="M70 95 Q60 82 70 72 Q80 60 95 68 Q100 55 115 60 Q132 58 135 75 Q150 80 145 100 Q155 110 140 122 Q135 138 118 135 Q108 146 92 140 Q75 144 70 128 Q55 122 60 105 Z" />
                <path d="M100 72 V140" />
                <path d="M85 85 Q100 95 115 85" />
                <path d="M80 110 Q100 120 120 110" />
            </g>
        </svg>
    );
}
